import { useQuery } from "@tanstack/react-query";
import { queryClient } from "shared/api/queryClient";
import { getTagDetails } from "../api/getTagDetails";

export const useTagDetailsQuery = (tagId: string) => {
  return useQuery({
    queryKey: ["tagDetails", tagId],
    queryFn: async () => {
      return await getTagDetails(tagId);
    },
    enabled: !!tagId,
    staleTime: 0,
  });
};

export const invalidateTagDetailsQuery = (tagId: string) => {
  return queryClient.invalidateQueries({ queryKey: ["tagDetails", tagId] });
};
